// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"60324eee","692":"2964c856"}[chunkId] + ".chunk.js";
};